import React from 'react'

export default function Search(props) {
  return (
    <svg width={props.width ? props.width : '30'} height={props.height ? props.height : '30'} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.7444 19.7639L26.25 26.25M22.5 13.125C22.5 18.3026 18.3026 22.5 13.125 22.5C7.94733 22.5 3.75 18.3026 3.75 13.125C3.75 7.94733 7.94733 3.75 13.125 3.75C18.3026 3.75 22.5 7.94733 22.5 13.125Z" stroke={props.color ? props.color : '#03555e'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
